/**
 * 数组随机
 * @param array 数组
 * @return Array
 */
export const GetArrDisorder = (array) => {
    // console.log(array);
    let res = [],
        random,
        lastOptionArr = [];
    while (array.length > 0) {
        random = Math.floor(Math.random() * array.length);
        res.push(array[random]);
        array.splice(random, 1);
    }
    return [...res, ...lastOptionArr];
}